<script setup>
import {computed, onMounted, onUnmounted, ref, watch} from 'vue'
import MessageHeader from '@/components/MessageHeader'
import PieChart from '@/components/charts/nChartsPie.vue'
import BarAndLineChart from '@/components/charts/nChartBarAndLine.vue'
import {
    init,
    chinaMap,
    destory,
    citys,
    citysTableData,
    expectIncrementDOM,
    totalChartDOM,
    chinaChartDOM,
    chinaChartBottomDOM,
    expectIncrementChart, totalChart, setCitys
} from './index'
import request from "@/service/request";
import {
    getCityGroupDimension,
    getCityGroupDimensionTip,
    getCityGroupList, getCityRate, getEffectiveRent, getIndustryRate,
    getStockAndIncrement,
    getTotalVolume
} from "@/service/api";
import {useRouter} from "vue-router";
import TabButtonGroup from "@/components/tabButtonGroup.vue";
import {useUrban} from "@/router/linkroute";
import {
  aggWarehouseArea, aggWarehouseAreaNoDivide,
  normalRate,
  rentPriceFormat,
  vacancyRate,
  vacancyRateNoMultiply, vacancyRateNoSuffixMultiply, vacancyRateWithSuffix,
  ymRate
} from "../../../tool/number";

onMounted(() => {
    init()
    getCityInfo()
});
const router = useRouter()

onUnmounted(destory);

function localeCompare(a, b){
  return a.localeCompare(b, 'zh-CN')
}

const loading = ref(true);
let time = localStorage.getItem('time')
let mapTime = localStorage.getItem('mapTime')

let selectName = ref('')
let cityList = ref([])

let authCityList = computed(() => {
  return cityList.value
      .map(e => e.groupname).sort(localeCompare);
})
let tipInfo = ref({
    title:'',
    remark:''
})
let hasAuth = ref(true);

// 城市群
const getCityInfo = async () => {
    loading.value = true;
    let {data} = await request({
        url: getCityGroupList,
        method: 'post',
        data: {
            groupname: '',
            quarter: mapTime
        }
    })
    loading.value = false;

    cityList.value = data || []
    if(data[0]){
       selectName.value = data[0].groupname;
    }
}
// 小结
const getTip = async () => {
    let {data} = await request({
        url: getCityGroupDimensionTip,
        method: 'post',
        data: {
            groupname: selectName.value,
            quarter: mapTime
        }

    })
    tipInfo.value = {
        title:data?data.title : '',
        remark:data?data.remark : '',
    }

}
// 预计增量
const getChart = async () => {
    let {data} = await request({
        url: getStockAndIncrement,
        method: 'post',
        data: {
            groupname: selectName.value,
            quarter: mapTime
        }

    })

    const result = data.map(item => {
      item.groupname = item.groupname.replace('城市群', '')
      return item;
    })
    .sort((a, b) => localeCompare(a.groupname, b.groupname))
    console.log(result);
    expectIncrementChart(result);
}
// 获取高标仓总体量
const getTotal = async () => {
    let {data} = await request({
        url: getTotalVolume,
        method: 'post',
        data: {
            groupname: selectName.value,
            quarter: mapTime
        }
    })
    totalChart(data)
}

// 城市群城市现有存量占比
const getRate = async () => {
    let {data} = await request({
        url: getCityRate,
        method: 'post',
        data: {
            groupname: selectName.value,
            quarter: mapTime
        }
    })
    setCitys(data)
}
// 行业占比
let industryData = ref([])
const getPieRate = async () => {
    let {data} = await request({
        url: getIndustryRate,
        method: 'post',
        data: {
            groupname: selectName.value,
            quarter: mapTime
        }
    })

    industryData.value = data.map(e => {
        return {
            name: e.category,
            value: e.rate
        }
    });
}
// 趋势图
let rentData = ref([])
const getRent = async () => {
    let {data} = await request({
        url: getEffectiveRent,
        method: 'post',
        data: {
            groupname: selectName.value,
            quarter: mapTime
        }
    })
    rentData.value = data;
}

async function getCitysTableData() {
    let {data} = await request({
        url: getCityGroupDimension,
        method: 'post',
        data: {
            groupname: selectName.value,
            quarter: mapTime
        }
    })

    citysTableData.value = (data || []).sort((a, b) => b.areatotal - a.areatotal)
      .map(e => {
      return {
        ...e,
        areatotal: aggWarehouseAreaNoDivide(e.areatotal),
        currentseasonadd: aggWarehouseAreaNoDivide(e.currentseasonadd),
        nettakeup: aggWarehouseAreaNoDivide(e.nettakeup),
        preadd: aggWarehouseAreaNoDivide(e.preadd),
        vacancyrate: vacancyRate(e.vacancyrate),
        avgprice: rentPriceFormat(e.avgprice)
      }
    })
}

function initData() {
    getTip()
    getChart()
    getTotal()
    getRate()
    getPieRate()
    getRent()
    getCitysTableData()
}

watch(selectName, () => {
    let row = cityList.value.find(item => item.groupname === selectName.value)
    if (!row) return;
    if (row.hasAuth){
      hasAuth.value = true;
      chinaMap(row);
      initData()
    }else{
      hasAuth.value = false;
    }
})

const handleSelect = (i) => {
    selectName.value =  authCityList.value[i]
}



</script>
<template>
    <div class="u-agg-box u-agg-box-group" v-loading="loading">
        <div class="u-header u-header-group">
          <div class="u-agg-top">
            <p>城市群数据概览</p>
            <span>数据时间：{{ time }}</span>
          </div>

          <MessageHeader msg="城市群市场现状"></MessageHeader>

          <div style="padding-top: 20px;">
            <tab-button-group
                :data="authCityList"
                @on-change-tab="handleSelect"
            />
          </div>
<!--          <ul class="u-agg-area-list">-->
<!--            <li v-for="item in cityList" :key="item.groupname" :class="{'current':selectName===item.groupname}"-->
<!--                @click="handleSelect(item.groupname)">{{ item.groupname }}-->
<!--            </li>-->
<!--          </ul>-->
        </div>
        <div class="u-agg-main" :class="hasAuth ? 'u-main-container': ''">
            <div class="u-agg-content u-agg-relative">
              <div class="content-shadow" v-show="!hasAuth">
                <div>您无{{ selectName }}权限，请联系销售人员</div>
              </div>
              <div class="u-agg-ps">
                  <div class="u-agg-area-content">
                      <div class="u-agg-ai-map">
                          <div ref="chinaChartBottomDOM" class="u-agg-ai-map-child"></div>
                          <div ref="chinaChartDOM" class="u-agg-ai-map-child"></div>
                      </div>
                      <div class="u-agg-ai-info">
                          <div class="u-agg-aii-text">
                              <p class="u-agg-aii-title">{{ tipInfo.title }}</p>
                              <div class="u-agg-aii-wa">{{ tipInfo.remark }}</div>
                          </div>
                          <div class="u-agg-aii-chart">
                              <div class="u-agg-aii-ctb">
                                  <p class="u-agg-aii-ct">现有存量与预计新增</p>
                              </div>
                              <div class="u-agg-aii-lb">
                                  <div class="u-agg-aii-legend">
                                      <div class="u-agg-aii-legend-item">
                                          <b class="u-agg-aii-block" style="background-color: #31C9E8;"></b>
                                          <span>现有存量</span>
                                      </div>
                                      <div class="u-agg-aii-legend-item">
                                          <b class="u-agg-aii-block" style="background-color: #C2DBEC;"></b>
                                          <span>预计增量</span>
                                      </div>
                                  </div>
                              </div>
                              <div ref="expectIncrementDOM" class="u-agg-aii-cc"></div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="u-agg-charts">
                  <div class="u-agg-chart-total">
                      <p class="u-agg-aii-ct">{{ selectName }}高标仓总体量</p>
                      <div class="u-agg-aii-legend">
                          <div class="u-agg-aii-legend-item">
                              <b class="u-agg-aii-block" style="background-color: #0A9BFC;"></b>
                              <span>高标仓总体量</span>
                          </div>
                          <div class="u-agg-aii-legend-item">
                              <div class="u-agg-aii-xx">
                                  <span style="background: #0A9BFC;"></span>
                                  <div style="border-color: #0A9BFC;"></div>
                              </div>
                              <span>占比全国高标仓比例</span>
                          </div>
                          <div class="u-agg-aii-legend-item">
                              <b class="u-agg-aii-block" style="background-color: #C2DBEC;"></b>
                              <span>预计增量</span>
                          </div>
                      </div>
                      <div ref="totalChartDOM" class="u-agg-chart-total-content"></div>
                  </div>
                  <div class="u-agg-chart-stock">
                      <p class="u-agg-aii-ct">{{ selectName }}城市现有存量占比</p>
                      <div class="u-agg-chart-stock-content">
                          <div v-for="item in citys" :key="item.name" class="u-agg-stock-line">
                              <label class="u-agg-stock-city">{{ item.name }}</label>
                              <div :style="{ 'backgroundColor': item.color[1] }" class="u-agg-stock-c">
                                  <div
                                      :style="{ 'width': item.value+'%', 'height': '100%', 'backgroundColor': item.color[0] }">
                                      <span :style="{right:item.value>10?0:'',left:item.value<10?0:''}">{{ normalRate(item.value) }}</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="u-agg-chart-industry">
                      <p class="u-agg-aii-ct">{{ selectName }}租户行业分布占比</p>
                      <div></div>
                      <div class="u-agg-chart-industry-content">
                          <PieChart :data="industryData"></PieChart>
                      </div>
                  </div>
                  <div class="u-agg-chart-estimate">
                      <p class="u-agg-aii-ct">{{ selectName }}预估有效租金与空置率趋势图</p>
                      <BarAndLineChart
                          :data="rentData"
                          :options="['dateYear','effectiveRent','vacancyrate']"
                          :labelOptions="['','']"
                          :label-format="['(元/㎡·月)', '']"
                          :value-format="[rentPriceFormat, vacancyRateWithSuffix]"
                          color="#54DD88"
                          not-show-y-name
                      />
                  </div>
              </div>
              <div class="u-agg-table">
                  <MessageHeader
                      :msg="selectName+'数据一览'"
                      tip-text="点击城市名称查看城市洞察"
                  />
                  <div class="u-agg-table-list rs-el-table">
                      <el-table :data="citysTableData">
                          <el-table-column align="center" label="序号" type="index" width="60"></el-table-column>
                          <el-table-column align="left" label="城市" prop="city">
                              <template  #default="scope">
                                  <router-link class="click-a click-a-normal" :to="useUrban(scope.row)" to>{{scope.row.city}}</router-link>
                              </template>
                          </el-table-column>
                          <el-table-column align="left" prop="areatotal">
                              <template #header>
                                  <span class="header-lable">
                                      现有存量（㎡)
                                      <el-tooltip content="建成面积（包含本季度增量）" effect="light" placement="top">
                                          <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65 header-tooltip"></i>
                                      </el-tooltip>
                                  </span>
                              </template>
                          </el-table-column>
                          <el-table-column align="left" header-align="left" prop="currentseasonadd">
                              <template #header>
                                  <span class="header-lable">
                                      本季度增量(㎡)
                                      <el-tooltip content="本季度建成面积" effect="light" placement="top">
                                          <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65 header-tooltip"></i>
                                      </el-tooltip>
                                  </span>
                              </template>
                          </el-table-column>
                        <el-table-column align="left" header-align="left" label="净吸纳量(㎡)" prop="nettakeup">
                        </el-table-column>
                          <el-table-column align="center" header-align="center" label="空置率" prop="vacancyrate" />
                          <el-table-column width="200" align="center" header-align="center" prop="avgprice">
                              <template #header>
                                  <span class="header-lable">
                                      预估有效租金(元/㎡·月)
                                      <el-tooltip content="折算免租期、装修期后的租金" effect="light" placement="top">
                                          <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65 header-tooltip"></i>
                                      </el-tooltip>
                                  </span>
                              </template>
                          </el-table-column>
                          <el-table-column align="left" header-align="left" prop="preadd">
                              <template #header>
                                  <span class="header-lable">
                                      预计增量(㎡)
                                      <el-tooltip content="预计投入市场的面积" effect="light" placement="top">
                                          <i class="iconfont icon-runtongyiyaoyihuifu_gantanhao-65 header-tooltip"></i>
                                      </el-tooltip>
                                  </span>
                              </template>
                          </el-table-column>
                      </el-table>
                  </div>
              </div>
              <div style="height: 30px;"></div>
            </div>
          </div>
        </div>
</template>
<style lang="less">
@import "../../../assets/css/public.less";
@import "./index.less";

.u-agg-box-group{
  display: flex;
  flex-direction: column;
  height: 100%;
}

.u-header-group{
  padding: 0 20px;
  height: 142px;
}

.u-main-container{
  flex-grow: 1;
  min-height: 0;
  overflow-y: scroll;
}

.el-table div.cell{
  line-height: 40px;
  height: 40px;
}

.click-a-normal{
  line-height: normal;
}

.u-agg-relative{
  position: relative;
}

.content-shadow{
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.6), #fff 30%);
  position: absolute;
  z-index: 9;
  width: 100%;
  height: 100%;

  & div{
    position: fixed;
    top: 50%;
    left: 50%;
    color: #f56c6c;
    text-align: center;
  }
}

.header-tooltip.iconfont{
  position: relative;
  top: -6px;
  font-size: 12px;
}
</style>